module.exports = "https://static.quthing.com/focus/img/bg_en1.png";